import { render, staticRenderFns } from "./HistoryEightHolter2.vue?vue&type=template&id=6005824a&scoped=true&"
import script from "./HistoryEightHolter2.vue?vue&type=script&lang=js&"
export * from "./HistoryEightHolter2.vue?vue&type=script&lang=js&"
import style0 from "./HistoryEightHolter2.vue?vue&type=style&index=0&id=6005824a&lang=less&scoped=true&"
import style1 from "./HistoryEightHolter2.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005824a",
  null
  
)

export default component.exports